import * as z from 'zod';

import { authenticationTypeQuerySchema } from '../components/authentication-type';

export const connectedAppQueryLinkerSchema = z.object({
  id: z.number(),
  service_name: z.string().min(2),
  authentication_type: authenticationTypeQuerySchema,
  description: z.string().nullable(),
  brand_id: z.number().nullable(),
  legal_entity_id: z.number().nullable(),
  client_id: z.string().nullable(),
  client_secret: z.string().nullable(),
  authorization_url: z.string().nullable(),
  auth_connected: z.boolean().nullable(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type ConnectedAppQueryLinkerSchema = z.infer<typeof connectedAppQueryLinkerSchema>;
